// extracted by mini-css-extract-plugin
export default {"container":"LoadingIndicator_container__UrIQZ","message":"LoadingIndicator_message__p4Gx4"};